import type { QueueItem, QueueTicket } from "~~/shared/types/queue.interfaces";

export const useQueuesController = () => {
  const userStore = useUserStore();
  const { $serverApi } = useNuxtApp();

  const getUserQueueTickets = async () => {
    const res = await $serverApi<GFALResponse<QueueTicket[] | null>>(
      `/api/queues`,
      {
        headers: constructHeaders(userStore.authToken),
      }
    );
    if (!res.payload) return [];
    return res.payload;
  };

  const getQueueById = async (itemId: string, merchantId: string) => {
    const res = await $serverApi<GFALResponse<QueueItem | null>>(
      `/api/queues/${merchantId + "_" + itemId}`,
      {
        headers: constructHeaders(userStore.authToken),
      }
    );
    if (!res.payload) return;
    return res.payload;
  };

  const cancelQueueTicket = async (itemId: string, merchantId: string) => {
    return await $serverApi<GFALResponse<null>>(
      `/api/queues/${merchantId + "_" + itemId}`,
      {
        method: "DELETE",
        headers: constructHeaders(userStore.authToken),
        body: {},
      }
    );
  };

  return {
    getUserQueueTickets,
    getQueueById,
    cancelQueueTicket,
  };
};
